module.exports = __webpack_public_path__ + "img/Mask Group 2883@2x.ff19f345.png";